import { OutlinedTextFieldProps, TextField } from "@mui/material";
import { useDraftValue } from "@/hooks/use-draft-value";

export interface DebouncedTextFieldProps extends Omit<
  OutlinedTextFieldProps,
  "value" | "onChange" | "variant"
> {
  value: string;
  onChange: (value: string) => void;
  commitDelayMs?: number;
}

/** A controlled TextField whose `onChange` fires after a typing pause or on blur, not on every keystroke. */
const DebouncedTextField = ({
  value,
  onChange,
  commitDelayMs,
  onBlur,
  ...rest
}: DebouncedTextFieldProps) => {
  const { draft, setDraft, commit } = useDraftValue(
    value,
    onChange,
    commitDelayMs
  );

  return (
    <TextField
      variant="outlined"
      {...rest}
      value={draft}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={(event) => {
        commit();
        onBlur?.(event);
      }}
    />
  );
};

export default DebouncedTextField;
